import { Typography } from '@mui/material'

export const Area = ({ value }) => {
  if (!value) return null
  return <Typography>{value} m²</Typography>
}
